// src/pages/Attendance/MyAttendanceTab.tsx
import React, { useState } from "react";
import CurrentUserAttendancePage from "./CurrentUserAttendancePage";
import StatusList, { StatusListType } from "./LeaveStatusList";

type MyAttendanceSection = "current" | StatusListType; 

const tabLabels: Record<MyAttendanceSection, string> = {
  current: "Regularize",
  pending: "Pending Requests",
  history: "History",
};

const MyAttendanceTab: React.FC = () => {
  const [activeSection, setActiveSection] = useState<MyAttendanceSection>("current");

  return (
<div className="max-w-7xl w-full mx-auto p-1">
      {/* Sub-tab buttons */}
      <div className="border-b border-gray-200 flex">
        {(Object.keys(tabLabels) as MyAttendanceSection[]).map((section) => (
          <button
            key={section}
            onClick={() => setActiveSection(section)}
            className={`flex-1 py-1.5 text-center text-sm font-medium transition-all duration-200 ${
              activeSection === section
                ? "text-blue-600 border-b-2 border-blue-500 font-semibold"
                : "text-gray-500 hover:text-blue-500"
            }`}
          >
            {tabLabels[section]}
          </button>
        ))}
      </div>

      {/* Sub-tab content */}
      <div className="mt-3 bg-white rounded-xl shadow-sm border border-gray-100 p-1">
        {activeSection === "current" && <CurrentUserAttendancePage />}

        {(activeSection === "pending" || activeSection === "history") && (
          <StatusList type={activeSection} context="regularization" />
        )}
      </div>
    </div>
  );
};

export default MyAttendanceTab;
